/*!
 * Copyright (c) Microsoft. All rights reserved.
 * Licensed under the MIT license. See LICENSE file in the project.
 */

import styled from 'styled-components'

export const Container = styled.div``
export const LabelContainer = styled.div`
	display: flex;
	justify-content: space-between;
`

export const icons = {
	remove: { iconName: 'StatusCircleErrorX' },
}
